import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import { useCallback, useRef } from 'react';
import { getCcFieldValidationMessage, getEmailContactLoadOptions, getEmailContactValue, getSelectOptionsFromContacts } from '../../utils/email';
import debounce from 'transmute/debounce';
import { useEmailShareTabContext } from '../../context/EmailShareTabContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const CcField = () => {
  const {
    selectedToValue,
    selectedCcValues,
    updateSelectedCcValues
  } = useEmailShareTabContext();
  const handleSelectedOptionChange = useCallback(event => {
    const options = event.target.value;
    updateSelectedCcValues(options.map(({
      record
    }) => record));
  }, [updateSelectedCcValues]);
  const validationMessage = getCcFieldValidationMessage(selectedCcValues, selectedToValue);
  const loadOptions = useRef(debounce(300, getEmailContactLoadOptions())).current;
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.emailTab.ccField.label"
    }),
    error: !!validationMessage,
    validationMessage: validationMessage,
    children: /*#__PURE__*/_jsx(UISelect, {
      className: "email-share-tab-cc-field",
      multi: true,
      onSelectedOptionChange: handleSelectedOptionChange,
      loadOptions: loadOptions,
      value: selectedCcValues.map(getEmailContactValue),
      options: getSelectOptionsFromContacts(selectedCcValues)
    })
  });
};